import { PayPubProductDto } from "../../../../../../api/pub-product";
import Header from "../../../../../../components/header";
import {
  ProductCartHeaderSelectorItem,
  ProductCartHeaderSelectorWrapper,
  ProductCartItemCountBox,
  ProductCartItemCountWrapper,
  ProductCartItemHeader,
  ProductCartItemInfo,
  ProductCartLine,
  ProductCartListItem,
  ProductCartListLine,
  ProductCartListWrapper,
  ProductCartMemoInput,
  ProductCartMemoInputTextCount,
  ProductCartMemoInputWrapper,
  ProductCartMemoWrapper,
  ProductCartMileageListItem,
  ProductCartMileageListWrapper,
  ProductCartMileageWrapper,
  ProductCartPayBox,
  ProductCartPayBoxContent,
  ProductCartWrapper,
} from "./styles/product-cart";
import { PubProductResponse } from "../../../../../../api/pub-product";
import { enqueueSnackbar } from "notistack";
import { loadingState } from "../../../../../../recoil/app";
import { useRecoilValue, useSetRecoilState } from "recoil";
import ProductTable from "./product-table";
import { useState } from "react";
import { createPortal } from "react-dom";
import ProductComplete from "./product-complete";
import { insetState } from "../../../../../../recoil/inset";

interface ProductCartProps {
  cart: PayPubProductDto[];
  mileage: number;
  setCart: (cart: PayPubProductDto[]) => void;
  seat: number | null;
  table: string | null;
  isPickUp: boolean;
  memo: string;
  setSeat: (seat: number | null) => void;
  setTable: (table: string | null) => void;
  setIsPickUp: (isPickUp: boolean) => void;
  setMemo: (memo: string) => void;
  payPubProduct: () => Promise<void>;
  setOpenProductCart: (open: boolean) => void;
  products: PubProductResponse[];
  setMileage: (mileage: number) => void;
}
const ProductCart = ({
  cart,
  mileage,
  setCart,
  seat,
  table,
  isPickUp,
  memo,
  setSeat,
  setTable,
  setIsPickUp,
  setMemo,
  payPubProduct,
  setOpenProductCart,
  products,
  setMileage,
}: ProductCartProps) => {
  const [openProductComplete, setOpenProductComplete] = useState(false);
  const inset = useRecoilValue(insetState);
  const setLoading = useSetRecoilState(loadingState);
  const findProduct = (id: number) => {
    return products.find((product) => product.id === id);
  };
  const handleRemove = (id: number) => {
    setCart(cart.filter((product) => product.pubProductId !== id));
  };

  const handleMinus = (id: number) => {
    const findProduct = cart.find((product) => product.pubProductId === id);
    if (findProduct && findProduct.count > 1) {
      setCart(
        cart.map((product) =>
          product.pubProductId === id
            ? { ...product, count: product.count - 1 }
            : product
        )
      );
    }
  };

  const handlePlus = (id: number) => {
    setCart(
      cart.map((product) =>
        product.pubProductId === id
          ? { ...product, count: product.count + 1 }
          : product
      )
    );
  };

  const totalPrice = cart.reduce((acc, product) => {
    return (
      acc + product.count * (findProduct(product.pubProductId)?.price ?? 0)
    );
  }, 0);

  const handlePayPubProduct = async () => {
    if (cart.length === 0) {
      enqueueSnackbar("장바구니에 상품을 추가해주세요. ", { variant: "error" });
      return;
    }

    if (!mileage) {
      enqueueSnackbar("마일리지가 없습니다. ", { variant: "error" });
      return;
    }
    if (mileage < totalPrice) {
      enqueueSnackbar("마일리지가 부족합니다. ", { variant: "error" });
      return;
    }

    if (!isPickUp && (!table || !seat)) {
      enqueueSnackbar("테이블을 선택해주세요. ", {
        variant: "error",
      });
      return;
    }
    try {
      setLoading(true);
      if (isPickUp) {
        setSeat(null);
        setTable(null);
      }
      await payPubProduct();
      setMileage(mileage - totalPrice);
      setCart([]);
      setMemo("");
      setSeat(null);
      setTable(null);
      setIsPickUp(true);
      setOpenProductComplete(true);
    } catch (e: any) {
      enqueueSnackbar("주문에 실패했습니다. ", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const cartContent = (
    <ProductCartWrapper>
      <Header title="장바구니" back={() => setOpenProductCart(false)} />
      <ProductCartHeaderSelectorWrapper isPickUp={isPickUp} inset={inset}>
        <ProductCartHeaderSelectorItem
          isSelected={isPickUp}
          onClick={() => {
            setIsPickUp(true);
          }}
        >
          직접 픽업
        </ProductCartHeaderSelectorItem>
        <ProductCartHeaderSelectorItem
          isSelected={!isPickUp}
          onClick={() => {
            setIsPickUp(false);
            if (!table) setTable("A");
          }}
        >
          테이블로 주문
        </ProductCartHeaderSelectorItem>
      </ProductCartHeaderSelectorWrapper>
      <ProductCartListWrapper>
        {cart.map((product, index) => (
          <>
            <ProductCartListItem key={index}>
              <img
                src={
                  findProduct(product.pubProductId)?.imageUrl ??
                  "/image-web/order/alcohol-default.png"
                }
                alt={findProduct(product.pubProductId)?.name ?? ""}
              />
              <ProductCartItemInfo>
                <ProductCartItemHeader>
                  <div className="box">
                    <div className="name">
                      {findProduct(product.pubProductId)?.name}
                    </div>
                    <div className="price">
                      {findProduct(
                        product.pubProductId
                      )?.price.toLocaleString()}{" "}
                      M
                    </div>
                  </div>
                  <img
                    src="/image-web/order/close.svg"
                    alt="close"
                    onClick={() => handleRemove(product.pubProductId)}
                  />
                </ProductCartItemHeader>
                <ProductCartItemCountWrapper>
                  <ProductCartItemCountBox width="25px">
                    <img
                      src="/image-web/order/minus.svg"
                      alt="minus"
                      onClick={() => handleMinus(product.pubProductId)}
                    />
                  </ProductCartItemCountBox>
                  <ProductCartItemCountBox width="52px">
                    {product.count}
                  </ProductCartItemCountBox>
                  <ProductCartItemCountBox width="25px">
                    <img
                      src="/image-web/order/plus.svg"
                      alt="plus"
                      onClick={() => handlePlus(product.pubProductId)}
                    />
                  </ProductCartItemCountBox>
                </ProductCartItemCountWrapper>
              </ProductCartItemInfo>
            </ProductCartListItem>
            {index < cart.length - 1 && <ProductCartListLine />}
          </>
        ))}
      </ProductCartListWrapper>
      <ProductCartLine />
      {!isPickUp && (
        <ProductTable
          seat={seat}
          setSeat={setSeat}
          table={table}
          setTable={setTable}
        />
      )}
      <ProductCartMemoWrapper>
        <div className="title">요청사항</div>
        <ProductCartMemoInputWrapper>
          <ProductCartMemoInput
            value={memo}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              setMemo(e.target.value);
              if (e.target.value.length > 50) {
                setMemo(e.target.value.slice(0, 50));
              }
            }}
          />
          <ProductCartMemoInputTextCount>
            {memo.length}/50
          </ProductCartMemoInputTextCount>
        </ProductCartMemoInputWrapper>
      </ProductCartMemoWrapper>
      <ProductCartLine />
      <ProductCartMileageWrapper>
        <div className="title">결제 마일리지</div>
        <ProductCartMileageListWrapper>
          {cart.map((product, index) => (
            <ProductCartMileageListItem key={index}>
              <div className="product">
                <span>{findProduct(product.pubProductId)?.name}</span>
                <span>{product.count}</span>
              </div>

              <div className="value">
                {(
                  product.count *
                  (findProduct(product.pubProductId)?.price ?? 0)
                ).toLocaleString()}{" "}
                M
              </div>
            </ProductCartMileageListItem>
          ))}
        </ProductCartMileageListWrapper>
      </ProductCartMileageWrapper>
      <ProductCartPayBox>
        <ProductCartPayBoxContent onClick={handlePayPubProduct}>
          {totalPrice.toLocaleString()} M 결제하기
        </ProductCartPayBoxContent>
      </ProductCartPayBox>
      {openProductComplete && (
        <ProductComplete
          onClose={() => {
            setOpenProductComplete(false);
            setOpenProductCart(false);
          }}
        />
      )}
    </ProductCartWrapper>
  );

  // React Portal을 사용하여 document.body에 직접 렌더링
  return createPortal(cartContent, document.body);
};

export default ProductCart;
